<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <a-form v-bind="formItemLayout" :form="addForm" @submit="handleOk">
      <a-form-item label="渠道名称">
        <a-input
          placeholder="请输入渠道名称"
          class="modal-form"
          v-decorator="
           ['channelName', { rules: [{ required: true, type: 'string', message: '渠道名称不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道类型">
        <a-select
          class="modal-form"
          placeholder="请选择渠道类型"
          v-decorator="
           ['channelType', { rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '渠道类型不能为空' }] }]"
        >
          <a-select-option value="01">银行</a-select-option>
          <a-select-option value="02">渠道</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="渠道状态">
        <a-select
          class="modal-form"
          placeholder="请输渠道状态"
          v-decorator="
           ['status', { rules: [{ required: true, message: '渠道状态不能为空' }] }]"
        >
          <a-select-option value="01">启用</a-select-option>
          <a-select-option value="02">禁用</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { formItemLayout } from '@/config'

export default {
  name: 'AddChannel',
  data: () => ({
    visible: false,
    loading: false,
    formItemLayout: Object.assign({}, formItemLayout, {
      // labelCol: {
      //   span: 6
      // },
      // wrapperCol: {
      //   span: 18
      // }
    }),
    addForm: undefined
  }),
  created () {
    this.addForm = this.$form.createForm(this, { name: 'addForm' })
  },
  methods: {
    handleCancel () {
      this.visible = false
      this.addForm.resetFields()
    },
    handleOk () {
      this.addForm.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true
          const { succ } = await this.$http.channel.channelAdd({ ...values })
          this.loading = false
          if (succ) {
            this.$message.success('新增成功！')
            this.handleCancel()
            this.$emit('success')
          }
        }
      })
    },
    handleClose () {
      this.startOpen = false
      this.endOpen = false
    }
  }
}
</script>

<style scoped>

</style>
